export default __webpack_public_path__ + "locales/pl/InfoPanel.json?hash=7f1d933056c1fdc18fe0852c688ea3e7";